import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { DEFAULT_LOCALE, LOCALE_STORAGE_KEY, SUPPORTED_LOCALES } from './localeTypes';
import { shellStrings } from './shellStrings';
function readStoredLocale() {
    if (typeof window === 'undefined')
        return DEFAULT_LOCALE;
    try {
        const v = window.localStorage.getItem(LOCALE_STORAGE_KEY)?.trim().toLowerCase();
        if (v === 'es' || v === 'en')
            return v;
    }
    catch {
        /* ignore */
    }
    return DEFAULT_LOCALE;
}
const LocaleContext = createContext(null);
export function useLocale() {
    const v = useContext(LocaleContext);
    if (!v)
        throw new Error('useLocale must be used within LocaleProvider');
    return v;
}
export const LocaleProvider = ({ children }) => {
    const [locale, setLocaleState] = useState(() => readStoredLocale());
    const setLocale = useCallback((next) => {
        if (!SUPPORTED_LOCALES.includes(next))
            return;
        setLocaleState(next);
        try {
            window.localStorage.setItem(LOCALE_STORAGE_KEY, next);
        }
        catch {
            /* ignore */
        }
    }, []);
    useEffect(() => {
        document.documentElement.lang = locale === 'es' ? 'es' : 'en';
        document.documentElement.setAttribute('data-portal-locale', locale);
    }, [locale]);
    const shell = shellStrings[locale];
    const value = useMemo(() => ({
        locale,
        setLocale,
        shell,
    }), [locale, setLocale, shell]);
    return _jsx(LocaleContext.Provider, { value: value, children: children });
};
